'use strict';

module.exports = function () {
    $('.user-account-btn').on('click', function () {
        $('.account-mobile').toggleClass('d-none');
        $('.search-mobile').toggleClass('d-none');
    });
};
